import type { TestIdsRecord, TestIdProp } from '../types';

import kebabToCamel from './kebabToCamel';

export default <Elements extends readonly string[]>(component: string, elements: Elements) =>
  (testIdProp?: TestIdProp['testId']): TestIdsRecord<Elements> => {
    const root = `${testIdProp ?? ''}:${component}:`;

    const obj = Object.fromEntries(elements.map(el => [kebabToCamel(el), `${root}${el}`]));

    obj.root = root;

    return obj as TestIdsRecord<Elements>;
  };
